import BordOneToneIcon from '../../NudosComponents/BordOneToneIcon/BordOneToneIcon';
import './Index.scss';

const SuccessIcon = () => {
  return (
    <div className="successIcon">
      <BordOneToneIcon variant="check" customWidth="2.24rem" stroke="#FFF" />
    </div>
  );
};

const InProgressIcon = () => {
  return (
    <div className="inProgressIcon">
      <BordOneToneIcon variant="loader" customWidth="2.24rem" stroke="#FFF" />
    </div>
  );
};

const WaitingIcon = () => {
  return (
    <div className="waitingIcon">
      <BordOneToneIcon variant="clock" customWidth="2.24rem" stroke="#999999" />
    </div>
  );
};

interface ICancelledIconProps {
  isSecondaryCancelled?: boolean;
}

const CancelledIcon = ({ isSecondaryCancelled = false }: ICancelledIconProps) => {
  const iconClass = isSecondaryCancelled ? 'secondaryCancelledIcon' : 'cancelledIcon';
  const strokeColor = isSecondaryCancelled ? '#999999' : '#FF0000';
  return (
    <div className={iconClass}>
      <BordOneToneIcon variant="x" customWidth="2.24rem" stroke={strokeColor} />
    </div>
  );
};

export { SuccessIcon, InProgressIcon, WaitingIcon, CancelledIcon };
